<template>
    <section>
        <p>各位亲爱的购卡人，在购卡之前，请认真阅读并理解以下协议：</p>

        <p>本协议是您与深圳畅行宝藏数字文旅科技有限公司(以下简称为“畅行宝藏文旅公司")之间就购买省卡所建立的契约。请您仔细阅读本协议,您点击“阅读并同意”按钮后,本协议即构成对双方有约束力的法律文件。</p>

        <p>畅行宝藏文旅公司依据本协议向“省卡”持卡人提供相应服务。畅行宝藏文旅公司在此特别提醒购卡人认真阅读、充分理解本协议各条款，特别是其中所涉及免除及限制畅行宝藏文旅公司责任的条款、对购卡人权利义务进行约束的条款等，本协议已使用粗体字对该等条款予以标注，请购卡人注意。请购卡人审慎阅读并选择接受或不接受本协议。购卡人确认，在接受畅行宝藏文旅公司服务，或以其他允许的方式实际使用畅行宝藏文旅公司服务前，购卡人已充分阅读、理解并接受本协议的全部内容。如果购卡人对本协议的条款有疑问，请通过畅行宝藏文旅公司官网公布的渠道进行咨询。</p>
        <p>第一条 畅行宝藏文旅公司系依法注册登记的机构，统一社会信用代码：91440300MA5GBPCC3Y。畅行宝藏文旅公司依照相关法律法规和公司经营范围，发行省卡系列产品，向持卡人提供便捷免门票入园服务。</p>
        <p>第二条 “省卡”可在所在省 家左右景区免预约入园 “省卡”服务内容和服务流程以畅行宝藏文旅公司官网（http://www.cytsszt.com）及微信公众号“中青自由行”公布为准。因景区供电、通讯、系统故障、服务系统崩溃等不可抗力原因导致持卡人使用“省卡”受阻的，畅行宝藏文旅公司可以为持卡人解决问题或提供必要的帮助，但不承担因此可能给持卡人造成的损失。</p>
        <p>对于该系列景区数量根据国家政策和景点流量动态调整，不另行通知，具体以公众号和小程序公告为准，请持卡人出行前核实。若出现下列情形之一，属于不可抗力，畅行宝藏文旅公司不承担责任：</p>
        <p>1、地方政府以明示或者暗示的方式禁止签约景区与畅行宝藏文旅公司合作；</p>
        <p>2、有关协会以明示或者暗示的方式限制签约景区与畅行宝藏文旅公司合作；</p>
        <p>3、因其他不可抗力造成实际可出游景区数量发生变化的。</p>
        <p>第三条 “省卡”是畅行宝藏文旅公司旗下的高端产品，可以免预约畅游所在省的旅游景点等应用领域。“省卡”使用期满可由持卡人通过网站、小程序等途径现金充值或者经自动扣费充值，“省卡”充值渠道以畅行宝藏文旅公司网站公布为准。持卡人与身份证手机号捆绑后，即可游玩上述景区，不提现、不退还、不计付利息。</p>
        <p>第四条 “省卡”99元/张。按畅行宝藏文旅公司定价销售，由本公司授权的代理商销售；若您是从非本公司官方授权的代理商处购买的假卡，本公司有权拒绝提供相应服务。有下列情形之一不予退卡：</p>
        <p>1、已经有过出票记录的；</p>
        <p>2、已经有过入园记录的；</p>
        <p>3、以景区库变化为由退卡的；</p>
        <p>4、以绑定信息有误要求退卡的；</p>
        <p>第五条“省卡”有效使用期限是指自激活日起壹年内，该卡可以正常使用。</p>
        <p>第六条 “省卡”在特定景区内可以无限次畅游，在非特定景区内每年可以畅游一次。具体景区由畅行宝藏文旅公司的官网及微信公众号“省卡”或相关票务服务系统的公布为准。</p>
        <p>第七条 “省卡”业务咨询可致电服务热线：400-608-0755。详细信息可以关注微信公众号“中青自由行”后了解。</p>
        <p>第八条 如有下列情况之一，畅行宝藏文旅公司不承担任何责任，所有损失均由持卡人承担。</p>
        <p>（一）景区休息、施工、或者因当地气候、交通、政府行为或不可抗力导致无法入园的；</p>
        <p>（二）持卡人违反本协议条款导致无法入园的；</p>
        <p>（三）省卡持卡人一次入园超过15人或者跟随旅行社入园的。</p>
        <p>第九条 畅行宝藏文旅公司的权利。</p>
        <p>（一）畅行宝藏文旅公司有权要求购买人在激活时按国家规定提供个人的身份信息及手机号码；</p>
        <p>（二）对于违反本协议使用省卡的，公司有权暂停该省卡的使用；</p>
        <p>（三）畅行宝藏文旅公司为持卡人提供的各种免费增值服务，畅行宝藏文旅公司有单方调整、暂停或终止的权利，且无须事先征得持卡人同意；</p>
        <p>（四）畅行宝藏文旅公司发现省卡存在误充值、误发卡、未付款误激活或因为计算机系统故障发生差错情形的，有权采取措施纠正错误，或采取冻结注销等措施，无须事先征得持卡人同意，持卡人应予以配合；</p>
        <p>（五）畅行宝藏文旅公司有权对持卡人及商户的注册资料及交易行为进行查阅，发现注册资料或交易行为中存在问题，或可能会导致不良后果的，有权发出询问，要求进一步提供必要的信息或直接对该省卡卡、该持卡人及相关交易作出相应的处理。如持卡人或商户利用“省卡”从事非法交易的，畅行宝藏文旅公司有权停止其业务，并依法向监管机构反馈相关情况；情节严重者，畅行宝藏文旅公司有权追究其相关法律责任。</p>
        <p>（六）畅行宝藏文旅公司有权根据具体情况增加、减少或撤消业务种类，也有权拒绝或取消不符合要求的持卡人及商户的交易资格，而无须预先通知持卡人；</p>
        <p>（七）持卡人同意，畅行宝藏文旅公司不对因下述任一情况而发生的服务中断或终止或其他入园不成功或受到影响等情形而承担任何赔偿责任：</p>
        <p>1、省卡交易系统停机维护升级期间；</p>
        <p>2、电信设备出现故障不能进行数据传输的；</p>
        <p>3、因台风、地震、海啸、洪水、停电、战争、恐怖袭击、政府行为等不可抗力因素，造成系统障碍不能执行业务的；</p>
        <p>4、由于黑客攻击、电信部门技术调整或故障、网站升级、银行方面的问题等原因造成的服务中断或者延迟；</p>
        <p>5、司法机关或行政机关依照法定程序要求畅行宝藏文旅公司中断对持卡人服务的；</p>
        <p>6、为公共利益的需要必须中断对持卡人服务的；</p>
        <p>7、因系统误操作导致信息局部有误等情形影响省卡使用的。</p>
        <p>8、其他必须中断或终止服务的情况。</p>
        <p>（八）除特别说明外，畅行宝藏文旅公司向持卡人提供的“省卡”、客户端运行软件等相关的知识产权均属畅行宝藏文旅公司所有。畅行宝藏文旅公司有权对持卡人的侵权行为追究相关责任。</p>
        <p>第九条 畅行宝藏文旅公司的义务</p>
        <p>（一）应当书面或通过畅行宝藏文旅公司网站等提供省卡使用的有关资料，包括协议、收费项目和使用说明等；</p>
        <p>（二）应当按约定通过有关渠道为持卡人提供服务，主要为畅行宝藏文旅公司官方网站、400-608-0755电话服务和服务网点服务。服务内容及服务时间以畅行宝藏文旅公司官网公布为准；</p>
        <p>（三）应依法对购买人的信息承担保密义务，未经当事人同意不得向任何单位或个人披露，但法律、法规和规章另有规定，或持卡人与发行机构另有约定，或持卡人自行授权的情况除外；</p>
        <p>（四）畅行宝藏文旅公司有义务在技术上确保整个系统平台的正常运行，保证持卡人顺利使用省卡提供的相关服务。</p>
        <p>（五）因系统误操作导致信息局部有误等情形影响省卡使用的，一经发现畅行宝藏文旅公司给予及时处理和更正。></p>
        <p>（六）畅行宝藏文旅公司有权调整上线景区而无需事先告知持卡人，持卡人可以享受系统提供的景区入园服务。></p>
        <p>第十条 持卡人的权利。></p>
        <p>（一）持卡人享有按规定使用省卡和获得相应服务的权利；></p>
        <p>（二）持卡人有权知悉省卡的功能、使用方法、收费项目及标准；></p>
        <p>（三）持卡人对省卡的注册激活、使用若有疑问，有权在规定时间内向畅行宝藏文旅公司提出查询或更正要求。></p>
        <p>第十一条 持卡人的义务。</p>
        <p>（一）持卡人应当向发行机构提供真实有效的身份信息及证明文件，不得冒用他人身份或使用伪造、变造身份证明文件购买省卡；</p>
        <p>（二）持卡人未妥善保管省卡，导致省卡遗失、灭失的，应当自行承担损失；</p>
        <p>（三）持卡人承诺在使用省卡时实施的所有行为遵守国家法律、法规以及各种社会公共利益或公共道德，不得利用省卡从事非法或不正当的交易。对于任何法律后果的发生，持卡人将以自己的名义独立承担所有相应的法律责任。上述行为包括但不限于：</p>
        <p>1、侵害他人名誉、隐私权、商业秘密、商标权、著作权、专利权、其他人身和财产权利；</p>
        <p>2、从事任何不法交易行为，如洗钱等行为；</p>
        <p>3、利用省卡进行无真实交易背景的虚假交易；</p>
        <p>4、从事任何可能含有电脑病毒或是可能侵害本服务系统、资料的行为；</p>
        <p>5、其他被畅行宝藏文旅公司有正当理由认为不适当的行为；</p>
        <p>对因持卡人违反上述条款，引致索赔、诉讼及其他程序致使畅行宝藏文旅公司受到损害的，应承担赔偿责任（包括合理的律师费用）。</p>
        <p>（四）购卡人可凭有效真实证件激活“省卡”。个人有效身份证件是指政府部门颁发的能够确认其身份并附有本人照片的身份证件，或者政府有权机关出具的能够证明其真实身份的证明文件，畅行宝藏文旅公司依法进行登记并核实信息（包括不限于视频、现场查验等方式）。</p>
        <p>（五）持卡人可以享受中青票务提供的第三方服务，但畅行宝藏文旅公司不承担任何第三方服务带来的损失和体验不顺畅的后果。</p>
        <p>（六）持卡人在入园时应向景区工作人员出示有效身份证件。</p>
        <p>（七）持卡人首次使用时，入园时间与激活时间不得少于3小时。</p>
        <p>第十二条 乙方已知悉，持有甲方旅游年卡的会员在入园期间的人身安全保障义务由入园景区负责并提供人身意外伤害保障；如发生意外，乙方应向入园景区主张相应权利和法律责任。</p>
        <p>第十三条 购卡人或持卡人与畅行宝藏文旅公司及其有关的代理人之间发生争议的，按照本协议及有关的法律法规进行处理。</p>
        <p>第十四条 本协议由畅行宝藏文旅公司制定、修改和解释。畅行宝藏文旅公司如对本协议进行修改，将通过公司网站公告修改后的协议。</p>
        <p>第十五条 如果持卡人继续使用畅行宝藏文旅公司提供的服务，则视为其接受畅行宝藏文旅公司对本协议相关条款的修改。</p>
        <p>本协议及今后畅行宝藏文旅公司制定的各项业务操作规定作为本协议不可分割的一部分，与本协议具有同等效力。</p>
        <p>第十六条 任何一方违反本协议的内容，给其他方造成损害的，应当承担相应责任，按照有关法律规定赔偿受损方由此造成的直接经济损失。</p>
        <p>第十七条 本协议未尽事宜按照国家有关法律、法规、规章及行业惯例执行。</p>
        <p>第十八条 本协议的任何条款如因任何原因而被确认无效，都不影响本协议其他条款的效力。</p>
        <p>第十九条  与本协议有关的一切争议，如无法通过协商解决，任一方可提交畅行宝藏文旅公司所在地有管辖权的人民法院解决。</p>
        <p>第二十条  本协议自2021年5月1日起生效执行。</p>

        <p class="tr">深圳畅行宝藏数字文旅科技有限公司</p>
        <p class="tr">二〇二一年五月一日</p>
    </section>
</template>

<script>
export default {
    name: 'ServiceAgreement',
    data() {}
}
</script>

<style lang="scss" scoped>
p {
    padding: 0 24px;
    width: calc(100% - 48px);
    font-size: 16px;
    line-height: 30px;
}
.tr {
    text-align: right;
}
</style>